export const PHONE_NUMBER = /^\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const URL = /^[A-Za-z][A-Za-z\d.+-]*:\/*(?:\w+(?::\w+)?@)?[^\s/]+(?::\d+)?(?:\/[\w#!:.?+=&%@\-/]*)?$/;
export const EMAIL =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const US_ZIPCODE = /\d{5}-?(\d{4})?/g;
export const CAN_POSTAL = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1}(?:\-| )?\d{1}[A-Z]{1}\d{1}$/i;
